// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router/index";
import ApiService from "./services/api.service";
import { TokenService } from "./services/storage.service";
import { store } from "./store/store";
import moment from "moment";
import logoutPlugin from "vue-auto-logout";
// Third party plugins
import VueSweetalert2 from "vue-sweetalert2";
import VueMeta from "vue-meta";
import jQuery from "jquery";
import * as VueGoogleMaps from "vue2-google-maps";
// import VTooltip from 'v-tooltip'

import PerfectScrollbar from "perfect-scrollbar";
window.PerfectScrollbar = PerfectScrollbar;

import "./assets/css/bootstrap.min.css";
import "./assets/css/bootstrap-extended.min.css";
import "./assets/css/colors.min.css";
import "./assets/css/components.min.css";
import "./assets/css/vertical-menu.min.css";
import "./assets/css/perfect-scrollbar.min.css";
import "./assets/css/feather.css";
import "./assets/css/style.css";

// Containers
import Header from "@/containers/Header";
import Sidebar from "@/containers/Sidebar";

// Modal
import CModal from "@/components/CModal";
import TwoFactorPrompt from "@/components/TwoFactorPrompt";

// Loader Animations
import CLoader from "@/components/loaders/CLoader";
import CLoaderRing from "@/components/loaders/CLoaderRing";

// Filters
import DateFilter from "./filters/date.js";

Vue.config.productionTip = false;

// Use jQuery globally
window.$ = window.jQuery = jQuery;
const logoutOptions = {
  stagnateTime: 6000000, // 2 hour
  detectTime: 15000,
  keyName: "access_token",
  clearAll: false
};

Vue.use(logoutPlugin, logoutOptions);
Vue.use(VueSweetalert2);
// Vue.use(VTooltip)
// Vue.directive('v-tooltip', VTooltip)
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAPS_KEY || "",
    libraries: "places" // necessary for places input
  }
});

Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
});

// camera icon
import { CameraIcon } from "vue-feather-icons";
import { ChevronLeftIcon } from "vue-feather-icons";

import Magnifier from "@/components/Magnifier";
import DashboardStat from "@/components/DashboardStat.vue";
import LoanStat from "@/components/LoanStat.vue";
import LoanTable from "@/components/LoanTable.vue";
import OtherLoanTable from "@/components/OtherLoanTable.vue";
import VerifyIdentity from "@/components/VerifyIdentity";
import ReviewOfficerStat from "@/components/ReviewOfficerStat";
import CollectionOfficerStat from "@/components/CollectionOfficerStat";

import PageLoader from "@/components/PageLoader.vue";
// import DisbursementOfficerStat from "@/components/DisbursementOfficerStat";

// Global use
// Vue.component("disbursement-stat", DisbursementOfficerStat);
Vue.component("collection-stat", CollectionOfficerStat);
Vue.component("review-stat", ReviewOfficerStat);
Vue.component("verify-identity", VerifyIdentity);
Vue.component("loan-stat", LoanStat);
Vue.component("loan-table", LoanTable);
Vue.component("other-loan-table", OtherLoanTable);
Vue.component("page-loader", PageLoader);
Vue.component("dashboard-stat", DashboardStat);
Vue.component("magnifier", Magnifier);
Vue.component("dash-header", Header);
Vue.component("dash-sidebar", Sidebar);
Vue.component("modal", CModal);
Vue.component("two-factor-prompt", TwoFactorPrompt);
Vue.component("loader-icon", CLoader);
Vue.component("loader-ring", CLoaderRing);
Vue.component("camera-icon", CameraIcon);
Vue.component("chevron-left-icon", ChevronLeftIcon);

Vue.filter("date", DateFilter);

Vue.filter("date_two", function(value) {
  if (value) {
    return moment(String(value)).format("DD/MMMM/YYYY");
  } else {
    return "";
  }
});

Vue.filter("date_three", function(value) {
  if (value) {
    const startDate = moment(String(value));
    const endDate = moment(); // Current date

    // Calculate the difference in years
    const yearsDifference = endDate.diff(startDate, "years");

    return `${yearsDifference} yrs old`;
  } else {
    return "";
  }
});
// console.log(process.env);
// Set the base URL of the API
ApiService.init(process.env.BASE_URL);
// ApiService.init("https://capital-metriq.testenv.com.ng/api/");
// If token exists set header
if (TokenService.getToken()) {
  ApiService.setHeader();
}
import "viewerjs/dist/viewer.css";
import VueViewer from "v-viewer";

Vue.use(VueViewer);

import permissionMixin from "./mixins/permission.mixin";
Vue.mixin(permissionMixin);

/* eslint-disable no-new */
new Vue({
  el: "#app",
  store: store,
  router,
  components: { App },
  template: "<App/>"
});
